




































































import UserLocationForm from '@/views/users/components/UserLocationForm.ts';
import { Component, Vue, Prop, Mixins, Emit } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import { AppMetadata, UserRoleLocation, UserData } from '@/views/users/Users';
import { Role } from 'auth0';

const AppStore = namespace('visitManagement');
const Tenants = namespace('tenants');

@Component({})
export default class UserRoleLocations extends Vue {
  private selectedLocation: UserRoleLocation = {};
  
  @Prop({ required: true })
  readonly id!: String;
  
  @Prop({ default: () => [] })
  private currentRoles!: Role[];
  
  @Prop({ required: true })
  private appMetadata!: AppMetadata;
  
  @Tenants.State
  private roles!: Role[]
  
  public get currentLocationRoles(): Role[] {
    return this.currentRoles.filter(item => (item.name || '').indexOf('loc_') > -1);
  }
  
  public get roleOptions (): Role[] {
    return this.roles.filter(item => (item.name || '').indexOf('loc_') > -1)
  }
  
  public get locationRoleNames() : any {
    return (id: String): String[] => {
      const { locations } = this.appMetadata
      
      const location = (locations || []).find(item => item.locationId === id);
      return [
        ...new Set(((location || {}).roles || [])
          .concat(this.currentRoles.map(item => item.name) as String[])
          .filter(item => item.indexOf('loc_') > -1)
        )
      ];
    }
  }
  
  public get locationRoles() : any {
    return (id: String): String[] => {
      return this.locationRoleNames(id).map((roleName: String) => {
        const role = this.roles.find(role => role.name === roleName)
        return role ? role.description || roleName : roleName
      })
    }
  }
  
  public get isCurrentRole (): any {
    return (id: string): Boolean => {
      return this.currentRoles.findIndex(item => item.id === id) > -1;
    }
  }
  
  @AppStore.Action
  private fetchLocations!: (params: QueryParams) => Promise<any>
  private locations?: ServerList = {};
  
  public setLocation (tr: any) {
    const { locations } = this.appMetadata
    this.selectedLocation = {
      locationId: tr.id,
      roles: this.locationRoleNames(tr.id)
    }
  }
  
  @Emit('update')
  public onChangeLocationRole (tr: any) {
    if (!this.appMetadata.locations) this.appMetadata.locations = [];
    const { locations } = this.appMetadata
    const locationIndex = (locations || []).findIndex(item => item.locationId === tr.id);
    if (locationIndex > -1) locations.splice(locationIndex, 1, this.selectedLocation)
    else locations.push(this.selectedLocation)
    this.selectedLocation = {};
    return this.appMetadata;
  }
  
  async created () {
    this.locations = await this.fetchLocations({
      limit: 9999,
      skip: 0
    })
  }
}
